import { IconCode } from "@multiweb/types/contracts";
import { EnumUtils } from "Global/Base/Utils/EnumUtils";
import { OWObjectList } from "OW.Remoting/Remoting/DataTypes/OWObjectList";
import { MEOWObject } from "UI/UI.Controls/DataSource/MultiEdit/MEOWObject";
import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../../../Global/Base/Rights/RightTypes";
import { IOWObject } from "../../../../../OW.Remoting/Remoting/DataTypes/IOWObject";
import { OWObject } from "../../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { IParticipantBase, IWorkflowMenuItem } from "../../../../../OW.Remoting/Remoting/IWorkflowManager";
import { IWFAction } from "../../../../UI.Controls/Actions/IAction";
import { StringBuilder } from "../../DataBuilders/StringBuilder";
import { MessageButtonType, MessageWindow } from "../../MessageWindow";
import { IMultiselectComponent } from "../Frames/FrameInterfaces";
import { IFrame } from "../IFrame";
import { WFActionBase } from "./WFActionBase";

export class WFAction extends WFActionBase implements IWFAction {
    public wfMenuItem: IWorkflowMenuItem;

    private readonly _object: OWObject;
    private _confirmMessage: string;

    constructor(wfAction: IWorkflowMenuItem, obj: OWObject);
    constructor(wfAction: IWorkflowMenuItem, owner: IFrame);
    constructor(wfAction: IWorkflowMenuItem, param: any) {
        super({ element: document.createElement("div"), originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION });

        if (param instanceof IOWObject) // případ použití komponenty z vnějšku (např. dashboard) - nepředává se celý frame, ale jen objekt, nad kterým se wf spouští
            this._object = (param as OWObject);
        else
            this.owner = param;

        this._init(wfAction);
    }

    protected _init(wfAction: IWorkflowMenuItem): void {
        this.wfMenuItem = wfAction;
        this.masterNode = wfAction.MasterNode;
        this.priority = wfAction.Order;
        this.caption = wfAction.ItemName;
        this.icon = EnumUtils.getEnumValueFromValue(IconCode, wfAction.IconName);
        this.validatePostReq = wfAction.ValidatePostReq;
        this.validateRecommended = wfAction.ValidateRecommended;
        this._confirmMessage = wfAction.ConfirmMessage;
        this._chooseFromUsersDefault = wfAction.ChooseFromUsersDefault;
        this._participantsSelecting = wfAction.ParticipantsSelecting;
        this._nextActivityID = wfAction.NextActivityID;

        this.visible = true;
    }

    protected override async _internalExecute(): Promise<void> {
        // zkontroluje se uložení změn na owneru a jeho nadřízených framech
        if (this.owner && !(await this._checkAndSaveForm()))
            return null;

        if (!(await this._checkRights(this.validateRecommended, this.validatePostReq, "GUI-51363"))) { //je potřebna kontrola vyplnění odložené povinných a/nebo doporučených polí, "GUI-51363" - spustit
            return null;
        }

        // pokud je akce spoustena nad framem, tak se z nej objekt nacte az pri spusteni akce
        const object = this.owner ? this.owner.actualObject : this._object;

        if (!(await this._confirmExecution()))
            return undefined;

        let objectList: OWObjectList;
        if (object instanceof MEOWObject && this.owner instanceof IMultiselectComponent) {
            objectList = this.owner.createSelectionObjectList();
        }

        let data: IParticipantBase[] = [];
        if (this._participantsSelecting) {
            try {
                data = await this._handleParticipantsWindow(object.instanceID, objectList, this._nextActivityID, this._chooseFromUsersDefault);
            } catch (e) {
                return undefined;
            }
        }

        await this._finishExecution(this.wfMenuItem, object, undefined, this._participantsSelecting ? data : undefined);
    }

    /**
     * Pokud je nastavena ConfirmMessage, zobrazí Yes/No dialog, pro potvrzení spuštění WF akce
     */
    private async _confirmExecution(): Promise<boolean> {
        if (this._confirmMessage) {
            const value = await MessageWindow.showYesNoDialog(new StringBuilder(this._confirmMessage));
            if (value.result === MessageButtonType.no)
                return false;
        }
        return true;
    }
}
